import BaseService from "@/services/base.service";

const API_URL = process.env.VUE_APP_API_URL;

class BankService extends BaseService {
    getCurrencies() {
        return this.get(API_URL + "/api/currencies").then(
            ({ data }) => data
        )
    }
    checkRequiredIban(country_code) {
        return this.post(API_URL + '/api/common/required-iban', {country_code: country_code}).then((response) => {
            return response.data;
        });
    }
}

export default new BankService();
